/** Code block copy functionality and enhanced code block UI */

export function initCodeBlocks(): void {
  const blocks = document.querySelectorAll('pre')
  const isEnglish = document.documentElement.lang.toLowerCase().startsWith('en')

  blocks.forEach((block) => {
    if (block.closest('.code-block')) return

    const code = block.querySelector('code')
    const classStr = [block.className, code?.className, block.closest('[class*="language-"]')?.className]
      .filter(Boolean)
      .join(' ')

    const langMatch = classStr.match(/language-([a-z0-9+#.-]+)/i)
    const lang = code?.dataset.lang || langMatch?.[1] || 'text'
    const langLabel = /^text$/i.test(lang)
      ? (isEnglish ? 'PROMPT EXCERPT' : '提示词摘录')
      : lang.toUpperCase()

    // Skip mermaid blocks
    if (/^mermaid$/i.test(lang)) return

    // Keep the original semantic pre/code tree and add only the UI around it.
    // Zola's highlighter emits one .giallo-l span per source line; preserving
    // those nodes keeps syntax colors, whitespace, selection, and scrolling.
    const wrapper = document.createElement('div')
    wrapper.className = 'code-block'
    wrapper.dataset.exhibitLabel = isEnglish ? 'EXHIBIT' : '样本'
    block.parentNode?.insertBefore(wrapper, block)
    wrapper.appendChild(block)
    block.classList.add('code-block__pre')

    const toolbar = document.createElement('div')
    toolbar.className = 'code-block__toolbar'

    const label = document.createElement('span')
    label.className = 'code-block__language'
    label.dataset.exhibitLabel = isEnglish ? 'EXHIBIT' : '样本'
    label.textContent = langLabel

    const copy = document.createElement('button')
    copy.type = 'button'
    copy.className = 'code-block__copy'
    copy.setAttribute('aria-label', isEnglish ? 'Copy code' : '复制代码')
    copy.textContent = isEnglish ? 'COPY' : '复制'

    toolbar.append(label, copy)
    wrapper.insertBefore(toolbar, block)
  })

  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement
    if (target.classList.contains('code-block__copy')) {
      const block = target.closest('.code-block')
      const code = block?.querySelector('code')
      const text = code?.textContent || ''

      navigator.clipboard?.writeText(text).then(() => {
        const tooltip = document.createElement('span')
        tooltip.className = 'code-block__copied'
        tooltip.textContent = isEnglish ? 'COPIED' : '已复制'
        target.after(tooltip)
        setTimeout(() => tooltip.remove(), 1500)
      })
    }
  })
}
